import React from 'react'

const ErrorShow = () => (
  <div className="error-page">Please sign in to use this feature.</div>
)

export default ErrorShow
